import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturedNews from './components/FeaturedNews';
import StreamingChannels from './components/StreamingChannels';
import Footer from './components/Footer';
import { Container, CssBaseline } from '@mui/material';
import Map from './components/Map';
import Contact from './components/Contanct';
import PlayStationLoader from './components/PlayStationLoader';
import BannerText from './components/BannerText';
import AboutUs from './components/AboutUs';
import BanerImg from './components/BanerImg';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [loading, setLoading] = useState(true);
  const [isSlowConnection, setIsSlowConnection] = useState(false);

  useEffect(() => {
    const handleConnection = () => {
      if (navigator.connection) {
        const { effectiveType } = navigator.connection;
        if (effectiveType === 'slow-2g' || effectiveType === '2g') {
          setIsSlowConnection(true);
        }
      }
    };

    handleConnection();

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1700);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <PlayStationLoader />;
  }

  return (
    <div style={{ background: 'black', cursor: 'pointer' }}>
      {isSlowConnection && (
        <div style={{ color: 'white', textAlign: 'center' }}>
          Ваше соединение медленное. Пожалуйста, подождите... c уважением Game
          Zone
        </div>
      )}
      <CssBaseline />
      <Header />
      <ScrollToTop />
      <Container maxWidth="lg">
        <HeroSection />
        <BannerText />
        <FeaturedNews />
        <AboutUs />
        <BanerImg />
        <StreamingChannels />
        <Contact />
        <Map />
      </Container>
      <Footer />
    </div>
  );
}

export default App;
